import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";

import logo from "../../icons/myIcons/logo.png";
import bg6 from "../../images/background/bg6.jpg";
import Select from "react-select";
import { loginApi } from "../../service/bankApi/login";
import {
  authenticate,
  setLoading,
  setUserDetails,
} from "../../feature/authSlice";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InputField from "../components/Fields/inputFields";
import { Button, Modal, Nav, Tab } from "react-bootstrap";
import {
  emailValidation,
  passwordValidation,
  phoneOnChange,
  phoneValidation,
} from "../../function/validation";
import PrimaryButton from "../components/Fields/primaryButton";
import Slider from "../components/swiper/swiper";
import { resendOtpApi } from "../../service/auth/resendPassword";
import PasswordField from "../components/Fields/passwordField";
import OtpModal from "../components/OtpModal/OtpModal";
import { getPermissions } from "../../service/auth/permissionsApi";
import { setPermissions } from "../../feature/permissions";
import ReCAPTCHA from "react-google-recaptcha";
import { Checkbox, FormControlLabel, Grid, Paper } from "@mui/material";
import { getRoles } from "../../service/auth/getRoles";
import axios from "axios";
import { RegisterUserApi } from "../../service/auth/RegisterUser";
import { findSubMenuByName } from "./propertyList/MenuUtlis";
import { redirectToDash } from "./redirectToDash";

function RegisterUser(props) {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [loadingActive, setLoadingActive] = useState(false);


const [roles, setRoles] = useState([]); // State to store roles from API

  const [selectedRoles, setSelectedRoles] = useState([]);
    const { permissions } = useSelector((state) => state.permissionsData);
  
  const propertiesMenu = findSubMenuByName(permissions, 'System');
  const listPropertyMenu = propertiesMenu ? findSubMenuByName(propertiesMenu?.SubMenus, 'User Registration') : null;

  useEffect(() => {
    if(!listPropertyMenu){
      redirectToDash(navigate,toast)
    }
  
}, [])
  // Handle role selection
  const handleRoleChange = (roleId) => {
    setSelectedRoles((prev) =>
      prev.includes(roleId)
        ? prev.filter((id) => id !== roleId) // Remove roleId if already selected
        : [...prev, roleId] // Add roleId if not selected
    );
  };


  function RegisterUser(){
        setLoadingActive(true);
        var data = {
            "Email":email,
            "FirstName": firstName,
            "LastName": lastName,
            "MobileNumber": phone,
            "CustomerId": 0,
            "PropertyId": 0,
            "SelectedRoles":selectedRoles
        };
        dispatch(
          RegisterUserApi(
            data,
            (res) => {
              setLoadingActive(false);
            },
            (err) => {
              setLoadingActive(false);
            }
          )
        );
  }
  function onLoadData(){
    dispatch(setLoading(true))
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}Identity/api/Account/GetRoles`,
      headers: { 
        'accept': '*/*'
      }
    };
    
    axios.request(config)
    .then((response) => {
      dispatch(setLoading(false))
     // console.log(response.data.result)
      setRoles(response.data.result); // Store roles in state
    })
    .catch((error) => {
      dispatch(setLoading(false))
      // console.log(error);
    });
    
  }
  
useEffect(() => {
  onLoadData()
  }, []);

const submit=(e)=>{
  e.preventDefault();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex

  if(!email){
  toast.error("Email is required.")
  return;
  }
  else if (!emailRegex.test(email)) {
toast.error("Please enter a valid email.")
return;
  }else if(!firstName){
    toast.error("First Name is required.")
    return;
  }else if(!lastName){
    toast.error("Last Name is required.")
    return;
  }
  else if(!phone){
    toast.error("Mobile Number is required.")
    return;
  }
  else if(selectedRoles.length===0){
    toast.error("Please Select atleast one role.")
    return;
  }
    
  setLoadingActive(true);
  var data = {
      "Email":email,
      "FirstName": firstName,
      "LastName": lastName,
      "MobileNumber": phone,
      "CustomerId": 0,
      "PropertyId": 0,
      "SelectedRoles":selectedRoles
  };
  dispatch(
    RegisterUserApi(
      data,
      (res) => {
        toast.success("User Registered Successfully")
        setEmail('')
        setPhone('')
        setFirstName('')
        setLastName('')
        setSelectedRoles([])
        setLoadingActive(false);
      },
      (err) => {
        toast.error(err?.data?.error?.exceptionMessage?.Error)
        setLoadingActive(false);
      }
    )
  );
}

  return (
    <>
      <ToastContainer />
      <div className=" " style={{ background: "#f1f1ff" }}>
  
          <Paper style={{borderRadius:"10px"}}>
          <div className="row mt-4">
                      <span
                        className="h4"
                        style={{ textAlign: "center", fontWeight: "600",marginTop:"20px" }}
                      >
                       Register user with Email
                      </span>
                    </div>
<br/>
                    <form onSubmit={submit}>
                  <div style={{padding:"20px"}}>
                  <Grid container spacing={1}>
<Grid item xs={12} sm={6}>
<InputField
                            labelName={"First Name"}
                            onChange={(e) => {
                              setFirstName(e.target.value)
                            }}
                            value={firstName}
                          />
</Grid>
<Grid item xs={12} sm={6}>
<InputField
                            labelName={"Last Name"}
                            onChange={(e) => {
                              setLastName(e.target.value)
                            }}
                            value={lastName}
                          />
</Grid>
<Grid item xs={12} sm={6}>
<InputField
                            labelName={"Email"}
                            onChange={(e) => {
                              setEmail(e.target.value)
                            }}
                            value={email}
                          />
</Grid>
<Grid item xs={12} sm={6}>
<InputField
                            labelName={"Mobile Number"}
                            onChange={(e) => {
                              const value = e.target.value;
                              const slicedMobile = value.slice(0,10); // Take last 10 digits
                              setPhone(slicedMobile)
                            }}
                            value={phone}
                          />
</Grid>
                        </Grid>
                  </div>
              <Grid container spacing={1} sx={{marginBottom:'20px',padding:'10px'}}>
                <div style={{padding:'20px'}}>
        <Grid item xs={12}>
          <span
            style={{ fontWeight: "600", marginBottom: "8px", display: "block" }}
          >
            Assign Roles:
          </span>
          <Grid container spacing={1}>
            {roles.map((role, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <FormControlLabel
                  control={
                    <Checkbox
                    checked={selectedRoles.includes(role.Name)} // Checked if selected
                    onChange={() => handleRoleChange(role.Name)} // Toggle selection
                    />
                  }
                  label={role?.Name}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
        </div>
        <Grid item xs={3}>
       <PrimaryButton
                        buttonName={"Register"}
                        type={"submit"}
                        isLoading={loadingActive}
                        loadingMessage={"Loading..."}
                        style={{
                          width: "100%",
                          marginBottom:"10px",
                        }}
                      />
        </Grid>
      </Grid>
                    </form>
          </Paper>
      </div>
    </>
  );
}

export default RegisterUser;
